module.exports = __webpack_public_path__ + "img/12.1.bd3e6c87.png";